import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { ITaskProgress } from './taskprogress.models';

type Props = {
  rows: ITaskProgress[];
};

export default class TaskProgressStatsBar extends React.PureComponent<Props> {
  renderCard(title: string, value: string | number) {
    return (
      <Grid size={{ xs: 6, md: 2.4 }}>
        <Paper elevation={1} sx={{ p: 1.5 }}>
          <Typography variant="caption" color="text.secondary">
            {title}
          </Typography>
          <Typography variant="h6">
            {value}
          </Typography>
        </Paper>
      </Grid>
    );
  }

  render() {
    const { rows } = this.props;

    const total = rows.length;
    const notStarted = rows.filter((r) => Number(r.rpr || 0) === 0).length;
    const inProgress = rows.filter((r) => Number(r.rpr || 0) > 0 && Number(r.apr || 0) < 100).length;
    const completed = rows.filter((r) => Number(r.apr || 0) >= 100).length;

    const avgApproved = total
      ? rows.reduce((s, r) => s + Number(r.apr || 0), 0) / total
      : 0;

    return (
      <Grid container spacing={1.5} sx={{ mb: 2 }}>
        {this.renderCard('Tasks', total)}
        {this.renderCard('Not Started', notStarted)}
        {this.renderCard('In Progress', inProgress)}
        {this.renderCard('Completed', completed)}
        {this.renderCard('Avg Approved', `${avgApproved.toFixed(1)}%`)}
      </Grid>
    );
  }
}